import useAppTranslation from "@hooks/language/useAppTranslation";
import { useBasketStore } from "@modules/order/stores/Basket.store";
import { IconUsers } from "@tabler/icons-react";
import type { GetInputPropsReturnType } from "node_modules/@mantine/form/lib/types";
import CodeInput from "./CodeInput";
interface IAffiliationProps extends GetInputPropsReturnType {
  onValidate: () => void;
  isValid: boolean;
  isDirty: boolean;
}

const AffiliationCodeInput: React.FC<IAffiliationProps> = ({ ...rest }) => {
  const { t } = useAppTranslation("pages.order.basket.codeInput");
  const { setAffiliationCodeInfo } = useBasketStore();

  return (
    <CodeInput
      buttonLabel={t("referral")}
      resetValidity={() =>
        setAffiliationCodeInfo({ isValid: false, isFilled: false })
      }
      icon={<IconUsers />}
      {...rest}
    />
  );
};

export default AffiliationCodeInput;
